// NumbersByLanguage
import React from 'react';

const NumbersByLanguage = ({ language }) => {
    const numbersColumn = {
        English: Array.from({ length: 100 }, (_, i) => (i + 1).toString()),
        Hindi: Array.from({ length: 100 }, (_, i) => String.fromCharCode(2406 + i)), // Devanagari numerals
        Marathi: Array.from({ length: 100 }, (_, i) => String.fromCharCode(2406 + i)), // Devanagari numerals
        Gujarati: Array.from({ length: 100 }, (_, i) => String.fromCharCode(2406 + i)), // Devanagari numerals
        Bangla: Array.from({ length: 100 }, (_, i) => String.fromCharCode(2534 + i)), // Bangla numerals
        Kannada: Array.from({ length: 100 }, (_, i) => String.fromCharCode(3302 + i)), // Kannada numerals
        Telugu: Array.from({ length: 100 }, (_, i) => String.fromCharCode(3174 + i)), // Telugu numerals
        Tamil: Array.from({ length: 100 }, (_, i) => String.fromCharCode(3046 + i)), // Tamil numerals
        Punjabi: Array.from({ length: 100 }, (_, i) => String.fromCharCode(2662 + i)), // Gurmukhi numerals
        Odia: Array.from({ length: 100 }, (_, i) => String.fromCharCode(2918 + i)), // Odia numerals
        Arabic: Array.from({ length: 100 }, (_, i) => String.fromCharCode(1632 + i)), // Arabic numerals
        Urdu: Array.from({ length: 100 }, (_, i) => String.fromCharCode(1776 + i)), // Arabic numerals
        Assamese: Array.from({ length: 100 }, (_, i) => String.fromCharCode(2534 + i)), // Bengali-Assamese numerals
        Javanese: Array.from({ length: 100 }, (_, i) => String.fromCharCode(2534 + i)), // Javanese numerals
        Chinese: Array.from({ length: 100 }, (_, i) => String.fromCharCode(12295 + i)), // Chinese numerals
        Japanese: Array.from({ length: 100 }, (_, i) => String.fromCharCode(12353 + i)), // Japanese numerals
        Russian: Array.from({ length: 100 }, (_, i) => String.fromCharCode(1040 + i)), // Cyrillic numerals
        Spanish: Array.from({ length: 100 }, (_, i) => String.fromCharCode(1632 + i)), // Arabic numerals
        French: Array.from({ length: 100 }, (_, i) => String.fromCharCode(1632 + i)), // Arabic numerals
        Burmese: Array.from({ length: 100 }, (_, i) => String.fromCharCode(1040 + i)), // Myanmar numerals
        German: Array.from({ length: 100 }, (_, i) => String.fromCharCode(1632 + i)), // Arabic numerals
        Italian: Array.from({ length: 100 }, (_, i) => String.fromCharCode(1632 + i)), // Arabic numerals
        Malayalam: Array.from({ length: 100 }, (_, i) => String.fromCharCode(3430 + i)), // Malayalam numerals
        Polish: Array.from({ length: 100 }, (_, i) => String.fromCharCode(318 + i)), // Polish numerals
        Portuguese: Array.from({ length: 100 }, (_, i) => String.fromCharCode(1632 + i)), // Arabic numerals
        Sinhala: Array.from({ length: 100 }, (_, i) => String.fromCharCode(3458 + i)), // Sinhala numerals
        Thai: Array.from({ length: 100 }, (_, i) => String.fromCharCode(3656 + i)), // Thai numerals
        Turkish: Array.from({ length: 100 }, (_, i) => String.fromCharCode(48 + i)), // Arabic numerals
        Vietnamese: Array.from({ length: 100 }, (_, i) => String.fromCharCode(48 + i)), // Latin numerals
        Korean: Array.from({ length: 100 }, (_, i) => String.fromCharCode(48 + i)) // Arabic numerals
    };

    const numbers = numbersColumn[language];

    const columns = Array.from({ length: 10 }, (_, i) => numbers.slice(i * 10, (i + 1) * 10));

    return (
        <div className="mx-auto max-w-[760px]">
  <div className="grid grid-cols-10 gap-0">
  {columns.map((_, colIndex) => (
  <div key={colIndex} className="flex flex-col">
    {columns[colIndex].map((number, rowIndex) => (
      <div key={`${colIndex}-${rowIndex}`} className={`${rowIndex % 2 !== 0 ? 'bg-gray-200' : 'bg-yellow-200'} text-black text-2xl flex justify-center items-center`}>
        {number}
      </div>
    ))}
  </div>
))}
  </div>
</div>
    );
};

export default NumbersByLanguage;
